import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import DonationSuccess from "@/pages/DonationSuccess";
import DonationCancel from "@/pages/DonationCancel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="top-center"
          richColors
          theme="light"
          toastOptions={{
            style: {
              background: "#FAF7F2",
              border: "1px solid #4A192C",
              color: "#2C1E23",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/don/merci" element={<DonationSuccess />} />
          <Route path="/don/annule" element={<DonationCancel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
